<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">






<!--sidebar-->
<ItemSidebar :name="$store.state.questionlists.questionlist.name" 
:brand="$store.state.questionlists.questionlist.brand"
:project="$store.state.questionlists.questionlist.project"
:sectioncount="sectioncount"
:questioncount="questioncount"
></ItemSidebar>
<!--sidebar-->














<div class="col-12 md:col-10">
<div class="content_card_content">
<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
export default {

  name: 'Questionlist',

  data () {
    return {
      item:null,
      tabs: [
          {
              title: 'genel',
              icon: 'list',
              route: 'general',
          },
          {
              title: 'sorular',
              icon: 'question-circle',
              route: 'questions',
          },
          {
              title: 'genel_secenekler',
              icon: 'list',
              route: 'general_options',
              show:"hide",
          },
          {
              title: 'genel_sutunlar',
              icon: 'table',
              route: 'general_options',
              show:"hide",
          },
          {
              title: 'hesaplama',
              icon: 'pencil',
              route: 'calculations',
              show:"show",
          },
          
          {
              title: 'soru_listesi_hesaplamalari',
              icon: 'pencil',
              route: 'questionlistsametypecalculations',
              show:"hide",
          },
          {
              title: 'soru_siniflari',
              icon: 'tag',
              route: 'inputfield_classes',
              show:"show",
          },
          {
              title: 'kosullar',
              icon: 'sort-alt',
              route: 'conditions',
          },
          {
              title: 'denetciler',
              icon: 'user',
              route: 'auditors',
          },
          {
              title: 'uygunsuzluk_tipleri',
              icon: 'user',
              route: 'nonconformity_types',
          },
          {
              title: 'bos_birakma_nedeni',
              icon: 'bookmark',
              route: 'null_reasons',
          }
      ],

    }
  },
  mounted()
  {    
    this.getData()
    this.checkTabName(this.tabs)
  },
  computed:{
    questonlist()
    {
      
      return this.$store.state.questionlists.questionlist
    },
    questonlisttype()
    {
      
      if(this.$store.state.questionlists.questionlist)
      {
        return this.$store.state.questionlists.questionlist.type
      }
      else
      {
        return ""
      }
      
    },
    sectioncount()
    {
      return this.$store.state.questionlists.sections.length
    },
    questioncount()
    {
      return this.$store.state.questionlists.inputfields.length
    },
  },
  watch:{
    questonlistyype(newVal)
    {
      
    },
    questonlist()
    {
      
       let ind_options = this.tabs.findIndex((item)=>{return item.title=="genel_secenekler"})
       let questionlistsametypecalculations = this.tabs.findIndex((item)=>{return item.title=="soru_listesi_hesaplamalari"})
       let inputfield_classes = this.tabs.findIndex((item)=>{return item.title=="soru_siniflari"})
       let calculations = this.tabs.findIndex((item)=>{return item.title=="hesaplama"})

      if(this.$store.state.questionlists.questionlist.type=="same_question_pattern")
      {
       
        this.tabs[ind_options].show = "show"
        
        //this.tabs[inputfield_classes].show = "show"
              
      }
      if(this.$store.state.questionlists.questionlist.type=="various_questions")
      {
        this.tabs[ind_options].show = "hide"
        
        //this.tabs[inputfield_classes].show = "hide"
      }
      if(this.$store.state.questionlists.questionlist.multiple_calculations)
      {
        this.tabs[questionlistsametypecalculations].show = "show"
        this.tabs[calculations].show = "hide"  
      }
      if(!this.$store.state.questionlists.questionlist.multiple_calculations)
      {
        this.tabs[questionlistsametypecalculations].show = "hide"
        this.tabs[calculations].show = "show"
      }

        
    }
  },
  methods:{
  	async getData()
    {
      console.log(this.$route)
        let item = await this.generalApiGet("questionlist/"+this.$route.params.id)
        console.log(item)        
        await this.$store.dispatch('questionlists/setQuestionlist',item) 
        this.item = await item
        for(let tab of this.tabs)
        {
          tab.route = await "/"+this.$store.state.auth.user.uuid+"/questionlist/"+this.$route.params.id+"/"+tab.route
        }
    }
  }
};
</script>

<style lang="css" scoped>
</style>